import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";

const initialState = {
  loading: false,
  portDetail: {
    level1: null,
    level2: null,
    level3: null,
  },
  securityDetail: null,
};

const slice = createSlice({
  initialState,
  name: "primaryPort",
  reducers: {
    reset: () => cloneDeep(initialState),
    getPortDetail: (state, action) => {
      state.loading = true;
      state.level = action.payload.level;
      state.portDetail[`level${action.payload.level}`] = null;
      state.error = null;
    },
    getPortDetailSuccess: (state, action) => {
      state.loading = false;
      state.portDetail[`level${state.level}`] = action.payload;
    },
    getPortDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getSecurityDetail: (state) => {
      state.loading = true;
      state.securityDetail = null;
    },
    getSecurityDetailSuccess: (state, action) => {
      state.loading = false;
      state.securityDetail = action.payload;
    },
    getSecurityDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    levelBack: (state) => {
      state.portDetail[`level${state.level}`] = null;
      state.level = state.level - 1;
    },
  },
});

export const {
  reset,

  getPortDetail,
  getPortDetailSuccess,
  getPortDetailFailure,

  getSecurityDetail,
  getSecurityDetailSuccess,
  getSecurityDetailFailure,
  levelBack,
} = slice.actions;

export default slice;
